<script>
export default {
    name: "ProductFeature",
    props: {
        title: {
            required: true,
            type: String,
        },
        description: {
            required: true
        }
    }
}
</script>

<template>
    <div class="group relative flex items-center justify-between dotted_line font-medium text-sm text-gray-700">
        <div class="bg-[#fcfcfc] z-1 pe-1 group-hover:text-indigo-600 transition">
            {{title}}
        </div>
        <div class="bg-[#fcfcfc] z-1 ps-1 group-hover:text-indigo-600 transition">
            {{description}}
        </div>
    </div>
</template>

<style scoped lang="scss">
.z-1 {
    z-index: 1;
}

.dotted_line:before {
    content: '';
    width: 100%;
    position: absolute;
    bottom: 5px;
    left: 0;
    border-bottom: 1px dotted #515151;
    transition: .25s;
}

.dotted_line:hover:before {
    border-bottom: 1px dotted var(--main-color);
}
</style>
